import { createFileRoute, Navigate } from '@tanstack/react-router';

import { ClientOnboardingTab } from '@apps/web/components/training/client_onboarding_tab';
import { useOrganizationId } from '@apps/web/hooks/use_organization_id';
import { useFeatureFlag } from '@apps/web/lib/feature_flag_overrides';
import { useOrganization } from '@apps/web/swr_data_fetching/organization_queries';

export const Route = createFileRoute('/_app/(main)/training/client-onboarding')(
    {
        component: ClientOnboardingRoute,
    },
);

function ClientOnboardingRoute() {
    const organizationId = useOrganizationId();
    const { data: organization } = useOrganization(organizationId, {
        reason: 'client-onboarding-route',
    });
    const clientAgent = useFeatureFlag(
        'client_agent_allowed',
        organization?.features,
    );
    // The flag arrives with the organization; deciding before it loads would
    // bounce a cold deep link off the page.
    if (!organizationId || !organization) {
        return null;
    }
    if (!clientAgent) {
        return <Navigate to="/training/announcement" replace={true} />;
    }
    return <ClientOnboardingTab organizationId={organizationId} />;
}
